import { render, staticRenderFns } from "./NutrientRequirementsModuleRoot.vue?vue&type=template&id=3552e239&scoped=true&lang=html&"
import script from "./NutrientRequirementsModuleRoot.vue?vue&type=script&lang=js&"
export * from "./NutrientRequirementsModuleRoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3552e239",
  null
  
)

export default component.exports